import { createSlice } from '@reduxjs/toolkit';

export const sessionDataPopulation = createSlice({
  name: 'SESSION_DATA_POPULATION',
  initialState: {}, // use the store, not initial state, which get overwritten by

  reducers: {
    setQuestionAndAnswers(state, action) {
      const { payload } = action;
      const { questionAndAnswers } = payload;
      return {
        ...state,
        questionAndAnswers,
      };
    },
    setAdvancePageStatus(state, action) {
      const { payload } = action;
      const { advancePageStatus } = payload;
      return {
        ...state,
        advancePageStatus,
      };
    },
  },
});

const { actions, reducer } = sessionDataPopulation;

export const { setQuestionAndAnswers, setAdvancePageStatus } = actions;

export default reducer;
